/* eslint-disable */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import { saveAs } from 'file-saver';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Button, IconButton } from '@mui/material';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import CloseIcon from '@mui/icons-material/Close';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import { ModalBM } from 'src/components/ModalBM';


export const ImagesBM = ({ url }) => {
  const imageEl = useRef(null);
  const [modal, setModal] = useState(false);
  const [rotation, setRotation] = useState(0); // current rotation

  // Rotate function
  const onRotate = (angle) => {
    const newRotation = rotation + angle;
    setRotation(newRotation);
    imageEl.current.style.transform = `rotate(${newRotation}deg)`;
  };

  // Reset rotation
  const resetRotation = () => {
    setRotation(0);
    imageEl.current.style.transform = `rotate(0deg)`;
  };

  // Image JSX
  const img = (style) => (
    <img
      src={url}
      alt="photos"
      ref={imageEl}
      style={{
        margin: '0 auto',
        width: 'auto',
        height: '100%',
        transition: 'transform 0.2s',
        ...style
      }}
    />
  );

  // Download image
  const downloadImage = () => {
    const fileName = `image_${Date.now()}.jpg`;
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => saveAs(blob, 'fileName'))
      .catch((err) => console.error('Error downloading image:', err));
  };

  return (
    <TransformWrapper initialScale={1} initialPositionX={0} initialPositionY={0}>
      {({ zoomIn, zoomOut, resetTransform }) => (
        <>
          {/* Main Controls */}
          <div style={{ float: 'right', zIndex: 2000 }}>
            <Button onClick={downloadImage}>Download</Button>
            <IconButton
              onClick={() => {
                setModal(true);
                resetTransform();
                resetRotation();
              }}
            >
              <FitScreenIcon />
            </IconButton>
          </div>

          {/* Main Image */}
          <TransformComponent
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <div
              style={{ width: 'auto', height: 'auto', maxHeight: '500px' }}
              onClick={() => {
                setModal(true);
                resetTransform();
                resetRotation();
              }}
            >
              {img()}
            </div>
          </TransformComponent>

          {/* Modal */}
          <ModalBM
            handelModal={() => setModal(false)}
            modelUp={modal}
            sx={{
              maxHeight: '90vh',
              overflow: 'auto',
              height: 'auto',
              width: 'auto',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <div>
              <TransformComponent>
                {img({ margin: '0 auto', width: 'auto', height: '90vh' })}
              </TransformComponent>
              <Controlles
                {...{
                  zoomIn,
                  zoomOut,
                  resetTransform: () => {
                    resetTransform();
                    resetRotation();
                  },
                  onRotate,
                  color: '#fff',
                  sx: {
                    zIndex: 1000,
                    position: 'fixed',
                    bottom: '10%',
                    left: '45%',
                    backgroundColor: '#000'
                  }
                }}
              />
            </div>
          </ModalBM>

          {/* Main Controls */}
          <Controlles
            {...{
              zoomIn,
              zoomOut,
              resetTransform: () => {
                resetTransform();
                resetRotation();
              },
              onRotate,
              color: '#000'
            }}
          />
        </>
      )}
    </TransformWrapper>
  );
};


const Controlles = ({ zoomIn, zoomOut, resetTransform, color, onRotate, sx }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...sx
    }}
  >
    <IconButton onClick={() => onRotate(10)}>
      <RotateRightIcon sx={{ color }} />
    </IconButton>
    <IconButton onClick={() => zoomIn()}>
      <ZoomInIcon sx={{ color }} />
    </IconButton>
    <IconButton onClick={resetTransform}>
      <CloseIcon sx={{ color }} />
    </IconButton>
    <IconButton onClick={() => zoomOut()}>
      <ZoomOutIcon sx={{ color }} />
    </IconButton>
    <IconButton onClick={() => onRotate(-10)}>
      <RotateLeftIcon sx={{ color }} />
    </IconButton>
  </div>
);

